import { Axios } from "./httpService";

export const RegisterSudent = (data) => {
  return Axios.post("/Student/RegisterSudent", data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};
export const EditSudent = (data) => {
  return Axios.put("/Student/EditProfileSudent", data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};
export const ShowProfile = () => {
  return Axios.get("/Student/ShowProfile");
};
export const ListGhavanin = () => {
  return Axios.get("/Student/ListGhavanin");
};
export const PriceGhavanin = () => {
  return Axios.get("/Student/ListRulePrice");
};
export const getRules = () => {
  return Axios.get("/Student/ListGhavanin");
};
export const ListJozveStudent = () => {
  return Axios.get("/Student/ListJozveStudent");
};
export const GetCartInfo = () => {
  return Axios.get("/Student/GetCartInfo");
};
export const GetJozveById = (id) => {
  return Axios.get(`/Student/GetJozveById/${id}`);
};
export const DeleteJozve = (id) => {
  return Axios.delete(`/Student/DeleteJozve/${id}`);
};
export const EditJozve = async (formData, onProgress) => {
  return await Axios.put("/Student/EditJozve", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
    onUploadProgress: (progressEvent) => {
      const percentage = Math.round(
        (progressEvent.loaded * 100) / progressEvent.total
      );
      onProgress(percentage);
    },
  });
};

export const AddJozve = async (formData, onProgress) => {
  return await Axios.post("/Student/AddJozve", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
    onUploadProgress: (progressEvent) => {
      const percentage = Math.round(
        (progressEvent.loaded * 100) / progressEvent.total
      );
      onProgress(percentage);
    },
  });
};

export const forgetPass = (phone) => {
  return Axios.get(`/User/ForgetPassword/${phone}`);
};
